import {Injectable} from "@angular/core";
import {DeviceRelocationModel, deviceRelocationModelFactory} from "../../device-relocation/device-relocation.model";
import {RelocateAssetBundleModel, relocateAssetBundleModelListFactory} from "./relocate-asset-bundle.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class DeviceRelocationWorkflowService {
  private url: string = "/api/devicerelocationworkflow";

  constructor(private http: HttpClient) {}

  updateRelocationDetails(deviceRelocation: DeviceRelocationModel): Promise<any> {
    return this.http.post(
      `${this.url}/update`,
      {
        id: deviceRelocation.id,
        name: deviceRelocation.name,
        siteId: deviceRelocation.siteId,
      },
    )
      .toPromise();
  }

  updateRelocationAssets(deviceRelocationId: string, assetIds: string[], accessoryIds: string[]): Promise<boolean> {
    return this.http.post(
      `${this.url}/update-assets`,
      {
        deviceRelocationId,
        assetIds,
        accessoryIds,
      },
    )
      .pipe(map(json => json["success"]))
      .toPromise();
  }

  getRelocationAssets(deviceRelocationId: string):
    Promise<{assets: RelocateAssetBundleModel[], closed: boolean, deploymentId: string}> {
    return this.http.get(`${this.url}/get-assets?deviceRelocationId=${deviceRelocationId}`)
      .pipe(map((json: any) => ({
        assets: relocateAssetBundleModelListFactory(json.assets),
        closed: !!json.closed,
        deploymentId: json.deploymentId || "",
      })))
      .toPromise();
  }

  isRelocationClosed(deviceRelocationId: string): Promise<boolean> {
    return this.http.get(`${this.url}/is-relocation-closed?deviceRelocationId=${deviceRelocationId}`)
      .pipe(map(json => json["closed"]))
      .toPromise();
  }

  finalizeRelocation(deviceRelocationId: string, deploymentName: string):
    Promise<DeviceRelocationModel> {
    return this.http.post(
      `${this.url}/finalize-relocation`,
      {deviceRelocationId, deploymentName},
    )
      .pipe(map(json => deviceRelocationModelFactory(json)))
      .toPromise();
  }
}
